import React from "react";
import ReactPlayer from "react-player";
import * as S from "./styles";

export const Slide10: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Wrapper>
          <S.Title>
            Nirvana <span>-</span>
            <br /> Smells Like Teen Spirit
          </S.Title>
          <S.Video>
            <ReactPlayer
              className="react-player"
              width="100%"
              height="100%"
              url="https://www.youtube.com/watch?v=hTWKbfoikeg"
            />
          </S.Video>
        </S.Wrapper>
      </S.Content>
      <S.Content className="right">
        <S.ContentWrapper>
          <S.Name>Marina Dias</S.Name>
          <S.Profile>Modelo e DJ</S.Profile>
          <S.Text>
            “Como adolescente que cresceu assistindo o boom dos videoclipes na
            MTV, tenho muitos preferidos, mas vou destacar dois: ‘Smells like
            teen spirit’, do Nirvana, que mudou a visão de todo mundo a respeito
            dos clipes. O outro é ‘Come to daddy’, do Aphex Twin, porque tem uma
            linguagem bem dark e foi dirigido por um cara bem freaky, o Chris
            Cunningham.”
          </S.Text>
        </S.ContentWrapper>
      </S.Content>
    </S.Container>
  );
};
